import { useEffect, useRef, useState } from "react";
import styles from "./Selfie.module.scss";
import Webcam from "react-webcam";
// import { Checkbox } from "@mui/material";
// import { blue } from "@mui/material/colors";

import useResponse from "../../hooks/useResponse";
import AfterOnboardAPI from "../../services/AfterOnboardAPI";
import { useDispatch, useSelector } from "react-redux";
import SelfieModal from "../../components/Modal/SelfieModal";

import { base64ToImageFile } from "../../utils/base64ToImage";
import Swal from "sweetalert2";
import SelfiePermissionModal from "../../components/Modal/SelfiePermissionModal/SelfiePermissionModal";
import { useNavigate } from "react-router-dom";

import { googleEvent_LOJ135, googleEvent_LOJ139_retake, googleEvent_LOJ139_submit } from "../../lib/google-analytics";
import AllowCameraPermission from "./AllowCameraPermission";
import { googleEvent_LOJ224, googleEvent_LOJ225 } from "../../lib/google-analytics-loan-journey-events";
import { checkCameraPermission } from "../../lib/script";
import { updateCameraAllowPermission } from "../../redux/slices/registerSlice";
import { clevertap_sv_selfie, clevertap_selfie_verification_success } from "../../lib/clevertap-events";

const label = { inputProps: { "aria-label": "Checkbox" } };

export default function Selfie() {
  const [loading, setLoading] = useState(false);
  // const [cameraAllowPermission, setCameraAllowPermission] = useState(false);

  const [image, setImage] = useState("");
  const [checkTerm, setCheckTerm] = useState(false);
  const [showSelfieSection, setShowSelfieSection] = useState(true);
  const [selfieAttempt, setSelfieAttempt] = useState(0);
  const [message, setMessage] = useState(null);

  const [openModal, setOpenModal] = useState(false);

  const [openPanModal, setOpenPanModal] = useState(false);

  const { userName } = useSelector((state) => state.user);
  const { loanAmount, cameraAllowPermission } = useSelector((state) => state.register);
  const { handleStep } = useResponse();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const webcamRef = useRef("");

  const { selfieLivenessAPI, getHypervergeFeatureAPI } = new AfterOnboardAPI();

  useEffect(() => {
    googleEvent_LOJ135();
    getHypervergeStatus();
    clevertap_sv_selfie();
  }, []);

  const getHypervergeStatus = async () => {
    try {
      const res = await getHypervergeFeatureAPI();
      if (res?.data?.HypervergeFlag) {
        navigate("/selfie-hyperverge");
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    const checkPermission = async () => {
      const permission = await checkCameraPermission();
      if (permission === "granted") {
        dispatch(updateCameraAllowPermission(true));
      } else {
        dispatch(updateCameraAllowPermission(false));
      }
    };

    checkPermission();
  }, [dispatch]);

  const videoConstraints = {
    facingMode: "user",
    width: 220,
    height: 200,
  };

  const captureSelfie = async () => {
    const imageSrc = webcamRef.current.getScreenshot();
    setImage(imageSrc);
    if (imageSrc) {
      handleSubmit(imageSrc);
    }
  };

  const handleSubmit = async (imageSrc) => {
    try {
      setLoading(true);
      const blob = await base64ToImageFile(imageSrc);
      const res = await selfieLivenessAPI(blob);
      Swal.fire({
        icon: "success",
        text: res?.data?.message || "Verified Successfully",
        timer: 3000,
      });
      clevertap_selfie_verification_success()
      handleStep();
    } catch (error) {
      Swal.fire({
        icon: "error",
        text: error?.response?.data?.message || "Something went wrong!",
        timer: 5000,
      });
      // if (error.status === 400 && error?.response) {
      //   const attempt = error?.response?.data?.data?.attempt;
      //   if (attempt === undefined) {
      //     navigate("/");
      //   }
      //   setSelfieAttempt(attempt);
      //   setOpenPanModal(true);
      // } else {
      //   Swal.fire({
      //     icon: "error",
      //     text: error?.response?.data?.message || "Something went wrong!",
      //     timer: 3000,
      //   });
      // }
    } finally {
      setLoading(false);
      setImage("");
      setShowSelfieSection(true);
    }
  };

  const checkPermissionDenied = (error) => {
    if (error.name === "NotAllowedError" || error.name === "PermissionDeniedError") {
      // setOpenModal(true);
      googleEvent_LOJ225("denied");
      navigate("/selfie-permission");
    }
  };

  if (!cameraAllowPermission) {
    return <AllowCameraPermission />;
  }
  return (
    <>
      <div className={`wrapper auto-height ${styles.verticalLine}`}>
        <div className="vertical-column-layout">
          <div className="vertical-column-top">
            <div className="header-progress mt-2">
              <div className="text">{78}%</div>
              <div className="progress-bar">
                <div className="progress-completed" style={{ width: `${78}%` }}></div>
              </div>
            </div>
            <p className="label mt-2">Selfie verification</p>
            <div className="fs-14 mt-1">Just a quick selfie to verify it's really you.</div>

            <div className={styles.webcamContainer}>
              <div className={styles.webcomBox}>
                {image == "" ? (
                  <Webcam
                    audio={false}
                    ref={webcamRef}
                    screenshotFormat="image/jpeg"
                    videoConstraints={videoConstraints}
                    className={styles.webcamCircle}
                    onUserMedia={async (event) => {
                      googleEvent_LOJ224();
                      if (event.active) {
                        const permission = await checkCameraPermission();
                        googleEvent_LOJ225(permission);
                      }
                    }}
                    onUserMediaError={(error) => checkPermissionDenied(error)}
                  />
                ) : (
                  <img src={image} className={styles.webcamCircle} alt="Capture selfie" />
                )}
              </div>
            </div>
            <div className={`${styles.bestResultSection}`}>
              <p className={styles.subLabel}>For the best results</p>
              <div className={styles.cardWrapper}>
                <div className="mb-2">
                  <div>
                    <div className={styles.cardBlocks}>
                      <div className={styles.innerItems}>
                        <img src="/images/lighting.png" alt="Good lighting tip" />
                        <p>
                          Good lighting on <br /> your face
                        </p>
                      </div>
                      <div className={styles.verticalDevider} />
                      <div className={styles.innerItems}>
                        <img src="/images/covering-face.png" alt="Remove face coverings tip" />
                        <p>
                          Remove anything <br /> covering your face
                        </p>
                      </div>
                    </div>

                    <div className={styles.devider}></div>

                    <div className={styles.cardBlocks}>
                      <div className={styles.innerItems}>
                        <img src="/images/center-face.png" alt="Keep face centered tip" />
                        <p>
                          Please keep your <br /> face in center
                        </p>
                      </div>
                      <div className={styles.verticalDevider} />
                      <div className={styles.innerItems}>
                        <img src="/images/neutral-expression.png" alt="Neutral expression tip" />
                        <p>
                          Keep a neutral <br /> expression
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {showSelfieSection ? (
            <>
              <div className={`vertical-column-bottom auto-height ${styles.selfieFloatingBtn}`}>
                <button
                  className="button"
                  onClick={() => {
                    setShowSelfieSection(false);
                    captureSelfie();
                  }}
                >
                  Click Selfie <i className="shine" />
                </button>
                <div className={styles.keepFloatingHeight} />
              </div>
              <div className={styles.keepFloatingHeight} />
            </>
          ) : (
            <>
              <div className={`vertical-column-bottom auto-height ${styles.selfieFloatingBtn}`}>
                {/* <div className={`${styles.accept} mb-2 mt-2`}>
                <Checkbox
                  {...label}
                  checked={checkTerm}
                  sx={{
                    color: blue[900],
                    "& .MuiSvgIcon-root": { fontSize: 28 },
                  }}
                  onChange={(e) => setCheckTerm(e.target.checked)}
                />
                <span>
                  I, {userName}, am taking ₹{loanAmount} worth of loan from
                  Ram Fincorp in sound mind and body
                </span>
              </div> */}

                <div className={styles.buttonGroup}>
                  <button
                    className={styles.retryButton}
                    onClick={() => {
                      setShowSelfieSection(true);
                      setImage(false);

                      googleEvent_LOJ139_retake("retake");
                    }}
                  >
                    Retry
                  </button>
                  <button
                    className={styles.submitButton}
                    // disabled={!checkTerm}
                    onClick={() => {
                      handleSubmit();
                      googleEvent_LOJ139_submit("submit");
                    }}
                  >
                    Submit
                  </button>
                </div>
              </div>
              <div className={styles.keepFloatingHeight} />
            </>
          )}
        </div>
      </div>

      <SelfieModal openPanModal={openPanModal} setOpenPanModal={setOpenPanModal} selfieAttempt={selfieAttempt} message={message} />

      <SelfiePermissionModal openModal={openModal} setOpenModal={setOpenModal} />
    </>
  );
}
